var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_104",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#9CA3AF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 5.33333V2.66667C8.66667 2.47778 8.73056 2.31944 8.85833 2.19167C8.98611 2.06389 9.14444 2 9.33333 2H13.3333C13.5222 2 13.6806 2.06389 13.8083 2.19167C13.9361 2.31944 14 2.47778 14 2.66667V5.33333C14 5.52222 13.9361 5.68056 13.8083 5.80833C13.6806 5.93611 13.5222 6 13.3333 6H9.33333C9.14444 6 8.98611 5.93611 8.85833 5.80833C8.73056 5.68056 8.66667 5.52222 8.66667 5.33333ZM2 8V2.66667C2 2.47778 2.06389 2.31944 2.19167 2.19167C2.31944 2.06389 2.47778 2 2.66667 2H6.66667C6.85556 2 7.01389 2.06389 7.14167 2.19167C7.26944 2.31944 7.33333 2.47778 7.33333 2.66667V8C7.33333 8.18889 7.26944 8.34722 7.14167 8.475C7.01389 8.60278 6.85556 8.66667 6.66667 8.66667H2.66667C2.47778 8.66667 2.31944 8.60278 2.19167 8.475C2.06389 8.34722 2 8.18889 2 8ZM8.66667 13.3333V8C8.66667 7.81111 8.73056 7.65278 8.85833 7.525C8.98611 7.39722 9.14444 7.33333 9.33333 7.33333H13.3333C13.5222 7.33333 13.6806 7.39722 13.8083 7.525C13.9361 7.65278 14 7.81111 14 8V13.3333C14 13.5222 13.9361 13.6806 13.8083 13.8083C13.6806 13.9361 13.5222 14 13.3333 14H9.33333C9.14444 14 8.98611 13.9361 8.85833 13.8083C8.73056 13.6806 8.66667 13.5222 8.66667 13.3333ZM2 13.3333V10.6667C2 10.4778 2.06389 10.3194 2.19167 10.1917C2.31944 10.0639 2.47778 10 2.66667 10H6.66667C6.85556 10 7.01389 10.0639 7.14167 10.1917C7.26944 10.3194 7.33333 10.4778 7.33333 10.6667V13.3333C7.33333 13.5222 7.26944 13.6806 7.14167 13.8083C7.01389 13.9361 6.85556 14 6.66667 14H2.66667C2.47778 14 2.31944 13.9361 2.19167 13.8083C2.06389 13.6806 2 13.5222 2 13.3333ZM3.33333 7.33333H6V3.33333H3.33333V7.33333ZM10 12.6667H12.6667V8.66667H10V12.6667ZM10 4.66667H12.6667V3.33333H10V4.66667ZM3.33333 12.6667H6V11.3333H3.33333V12.6667Z",
    fill: "#9CA3AF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/DashboardIcon.12deec84f40b42a65dbb38c0a2afc839.svg";
export { ForwardRef as ReactComponent };